<template>
  <div style="width:257px">
    <!-- <treeselect 
			v-model="value" 
			:multiple="true" 
			:options="options.map(el => ({
				value: el.branch_id,
				id:el.branch_id, label: el.branch_name_en
			}))"
			:limit="1"
			:limitTex="20"	
			:placeholder="$t('filter_by_branch')"
			@input="input"
    />-->
    <a-select
      v-model="value"
      showSearch
      mode="multiple"
      class="ts-w-full"
      optionFilterProp="children"
      :loading="loading"
      :maxTagTextLength="17"
      :maxTagCount="1"
      :placeholder="showPlaceholder ? $t('location_filter') : null"
      :options="
        options.map(el => ({
          value: el.location_id,
          label: el.location_name_en
        }))
      "
      :filterOption="
        (input, option) =>
          option.componentOptions.children[0].text
            .toLowerCase()
            .indexOf(input.toLowerCase()) >= 0
      "
      @change="changeValue"
    />
  </div>
</template>

<script>
export default {
  name: 'branchFilter',
  props: {
    showPlaceholder: {
      type: Boolean,
      default: true
    },
    isDefaultSelect: {
      type: Boolean,
      default: true
    },
    branchId: {
      type: [Array, Number],
      default: () => []
    }
  },
  data() {
    return {
      value: [],
      options: [],
      loading: false
    }
  },
  created() {
    this.fetchLocation()
  },
  methods: {
    fetchLocation() {
      this.loading = true
      this.$store
        .dispatch('security/user/getWarehouseAssigned', {
          branch_id: this.branchId
        })
        .then(response => {
          this.options = response.data
          if(!this.branchId.length){
            this.selectDefault()
          }
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    selectDefault() {
      if (!this.isDefaultSelect) {
        return
      }

      let defaultLocation = this.options.filter(o => o.is_default == true)
      if (defaultLocation.length > 0) {
        this.value.push(defaultLocation[0].location_id)
        this.$emit('filter', this.value)
      }
    },
    changeValue() {
      this.$emit('filter', this.value)
    }
  },
  watch: {
    branchId: function(value) {
      if (Array.isArray(value)) {
        this.fetchLocation()
      }
    }
  }
}
</script>
<style lang="css" scoped>
.vue-treeselect__control {
  height: 34px !important;
}
</style>
